import React from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import * as Yup from "yup";

import Button from "../../components/button";
import ICInput from "../../components/form/input";

const ConsultGstForm = props => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      gst: props.gst ? props.gst : ""
    },
    validationSchema: Yup.object({
      gst: Yup.string().required(`Please enter ${props.gstName}`)
    }),
    onSubmit: values => {
      let formData = new FormData();
      formData.append('tax', values.gst);
      props.onUpdateFormSubmit(formData, "GST");
    }
  });

  return (
    <form
      className="d-flex flex-column mr-4 pr-4"
      onSubmit={formik.handleSubmit}
    >
      <div className="form-group row">
        <label className="col-sm-7 col-form-label">
          {props.gstName} <span className="error">*</span>:
        </label>
        <div className="col-sm-5">
          <ICInput
            name="gst"
            type="text"
            value={formik.values.gst}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </div>
      </div>
      <br />
      <p className="mb-0 d-flex justify-content-center">
        <Button title="Save" type="submit" />
      </p>
    </form>
  );
};

export default ConsultGstForm;

ConsultGstForm.defaultProps = {
  gstName: "Practice Management Fee ($)",
  gst: "",
  onUpdateFormSubmit: () => {}
};

ConsultGstForm.propTypes = {
  gstName: PropTypes.string,
  gst: PropTypes.string,
  onUpdateFormSubmit: PropTypes.func
};
